import React from 'react'
import styled from 'styled-components'
import BodyText from '../Typography/BodyText'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

interface Props {
  stepLabel: string
  currentStepNumber: number
  totalSteps: number
}

function StepperProgressText(props: Props) {
  const {
    stepLabel,
    currentStepNumber,
    totalSteps,
  } = props

  return <Container>
    <BodyText variant="medium" weight="bold" colour="neutral-one">{stepLabel}</BodyText>
    <BodyText variant="small" colour="neutral-two">Step {currentStepNumber} of {totalSteps}</BodyText>
  </Container>
}

export default StepperProgressText
